import React from 'react';
import { MapPin, Phone, Clock, Navigation } from 'lucide-react';
import { businessData } from '../mock';

const Contact = () => {
  return (
    <div className="page-contact">
      {/* Hero */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-title">Kontakt</h1>
          <p className="page-subtitle">
            Find os på Nørrebro – vi glæder os til at se dig
          </p>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-section">
        <div className="contact-container">
          <div className="contact-grid">
            {/* Contact Info */}
            <div className="contact-info-wrapper">
              <h2 className="contact-section-title">Kontakt information</h2>
              
              <div className="contact-info-block">
                <div className="contact-info-icon">
                  <MapPin size={24} />
                </div>
                <div className="contact-info-content">
                  <h3 className="contact-info-label">Adresse</h3>
                  <p className="contact-info-text">
                    {businessData.address.street}<br />
                    {businessData.address.postal}<br />
                    {businessData.address.country}
                  </p>
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                      businessData.address.street + ', ' + businessData.address.postal
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="contact-map-link"
                  >
                    <Navigation size={16} />
                    Åbn i Google Maps
                  </a>
                </div>
              </div>

              <div className="contact-info-block">
                <div className="contact-info-icon">
                  <Phone size={24} />
                </div>
                <div className="contact-info-content">
                  <h3 className="contact-info-label">Telefon</h3>
                  <a href={`tel:${businessData.phone}`} className="contact-phone-link">
                    {businessData.phone}
                  </a>
                  <p className="contact-info-note">
                    Ring for at booke en tid. Ingen online booking.
                  </p>
                </div>
              </div>

              <div className="contact-info-block">
                <div className="contact-info-icon">
                  <Clock size={24} />
                </div>
                <div className="contact-info-content">
                  <h3 className="contact-info-label">Åbningstider</h3>
                  <div className="contact-hours-list">
                    {businessData.openingHours.map((item, index) => (
                      <div key={index} className="contact-hours-row">
                        <span className="contact-day">{item.day}</span>
                        <span className="contact-time">{item.hours}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Map */}
            <div className="contact-map-wrapper">
              <iframe
                title="Herrefrisør location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2247.3286944789686!2d12.553944!3d55.698433!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4652531c8b8e8b8b%3A0x8b8e8b8e8b8e8b8b!2sThorsgade%204%2C%202200%20K%C3%B8benhavn!5e0!3m2!1sen!2sdk!4v1234567890123"
                className="contact-map"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </section>

      {/* Directions Section */}
      <section className="directions-section">
        <div className="directions-container">
          <h2 className="directions-title">Find vej til os</h2>
          <div className="directions-grid">
            <div className="direction-card">
              <h3 className="direction-title">Med offentlig transport</h3>
              <p className="direction-text">
                Busser: 5C, 350S stopper tæt på Thorsgade. Gå få minutters gang til Thorsgade 4.
              </p>
            </div>
            <div className="direction-card">
              <h3 className="direction-title">Med cykel</h3>
              <p className="direction-text">
                Der er cykelstativer lige uden for salonen. Nørrebro er cyklistvenlig hele året.
              </p>
            </div>
            <div className="direction-card">
              <h3 className="direction-title">Parkering</h3>
              <p className="direction-text">
                Gadeparkering på Thorsgade og omkringliggende gader. Husk parkeringsafgift i dagtimerne.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="contact-cta-section">
        <div className="contact-cta-container">
          <h2 className="contact-cta-title">Klar til at besøge os?</h2>
          <p className="contact-cta-text">
            Ring og book en tid – vi ser frem til at byde dig velkommen
          </p>
          <a href={`tel:${businessData.phone}`} className="cta-button">
            <Phone size={20} />
            {businessData.phone}
          </a>
        </div>
      </section>
    </div>
  );
};

export default Contact;